import { Order } from "./table-sort.types";

export const sortData = <T>(
    data: T[],
    property: keyof T,
    order: Order
): T[] => {
    return data.slice().sort((a, b) => {
        const valueA = a[property];
        const valueB = b[property];

        if (valueA === null && valueB === null) return 0;
        if (valueA === null) return order === Order.ASCENDING ? -1 : 1;
        if (valueB === null) return order === Order.ASCENDING ? 1 : -1;

        if (typeof valueA === 'number' && typeof valueB === 'number') {
            return order === Order.ASCENDING ? valueA - valueB : valueB - valueA;
        }

        if (typeof valueA === 'string' && typeof valueB === 'string') {
            return order === Order.ASCENDING ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        }

        return 0;
    });
};